import { memo } from 'react';
import { Lightbulb } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function IdeaNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={Lightbulb} nodeType="idea" />;
}

export const IdeaNode = memo(IdeaNodeComponent);
